import mutations from './patient.mutations'
import actions from './patient.actions'
import getters from './patient.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
